import NotificationsForm from "./NotificationsForm/index";

export default {
  NotificationsForm
};
